// Import Redux Types
import {
  DOWNLOAD_GENERAL_DATA,
  SUCCESS_DOWNLOAD_GENERAL_DATA,
  ERROR_DOWNLOAD_GENERAL_DATA,
  PLAY_SOUND,
  SHOW_LOADER,
  SET_CURRENT_OFFERING
} from '../types/index'
// Import Services
import { get } from '../services/api'



// Functions
export function downloadGeneralDataAction() {
  return async ( dispatch:any ) => {
    dispatch( downloadGeneralData() )
    try {
      const response = await get('f0h3')
			dispatch( successDownloadGeneralData( response ) )
    } catch(error) {
      dispatch( errorDownloadGeneralData() )
    }
  }
}
const downloadGeneralData = () => ({
  type: DOWNLOAD_GENERAL_DATA
})
const successDownloadGeneralData = (data:any) => ({
  type: SUCCESS_DOWNLOAD_GENERAL_DATA,
  payload: data
})
const errorDownloadGeneralData = () => ({
  type: ERROR_DOWNLOAD_GENERAL_DATA
})


export function playSoundAction( willPlayed:boolean ) {
  return async ( dispatch:any ) => {
    dispatch( playSound(willPlayed) )
  }
}
const playSound = ( willPlayed:boolean ) => ({
  type: PLAY_SOUND,
  payload: willPlayed
})


export function showLoaderAction( willVisible:boolean ) {
  return async ( dispatch:any ) => {
    dispatch( showLoader( willVisible ) )
  }
}
const showLoader = ( willVisible:boolean ) => ({
  type: SHOW_LOADER,
  payload: willVisible
})


export function setCurrentOfferingAction( offering:{} ) {
  return async ( dispatch:any ) => {
    dispatch( setCurrentOffering( offering ) )
  }
}
const setCurrentOffering = ( offering:{} ) => ({
  type: SET_CURRENT_OFFERING,
  payload: offering
})
